import { createContext, type ReactNode, useContext } from "react";
import { useLocation } from "react-router";
import { LandingContentProvider } from "../modules/public/lp-content/context";
import { DEFAULT_SITE, resolveSite, type SiteConfig } from "./catalog";

const SiteContext = createContext<SiteConfig>(DEFAULT_SITE);

export function useSite(): SiteConfig {
	return useContext(SiteContext);
}

export function SiteRoot({ children }: { children: ReactNode }) {
	const location = useLocation();
	const hostname = typeof window === "undefined" ? "localhost" : window.location.hostname;
	const site = resolveSite(hostname, location.search);

	return (
		<SiteContext.Provider value={site}>
			<LandingContentProvider content={site.lpContent}>
				<div className={site.themeClass} data-site-id={site.siteId} data-testid="site-root">
					{children}
				</div>
			</LandingContentProvider>
		</SiteContext.Provider>
	);
}
